import axios from "axios"

const baseURL = 'https://ndc.pay1.in'

const axiosInstance = axios.create({
    baseURL,
})

axiosInstance.interceptors.request.use(
    async (config) => {
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

axiosInstance.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response && error.response.status === 401) {
        }
        return Promise.reject(error)
    }
)

const time = new Date().getTime()
export const postReq = (path, data) => {
    return axiosInstance.post(`${path}?time=${time}`, data)
}